import React, { Component } from 'react';
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';


class FooterSlider extends Component {
            
 

    render() { 

       const srcImage = []

        const responsive = {
            0: { items: 1 },
            568: { items: 2 },
            1024: { items: 3 },
            1400: { items: 4 },
          
        };
        const handleDragStart = (e) => e.preventDefault();

        // {this.props.sliderObject.map((tag,index) => ( 
             
        //           srcImage.push(<a href="https://www.facebook.com/"><img src={tag.image} onDragStart='handleDragStart'/><a/></a>)
          
                

        // ))}
        var  images = ['welcome' , 'assets/amc.png' , 'assets/licious.jpg' ,'assets/profish.jpg' , 'assets/monmouth.png' , 'assets/seychelles.jpg'];
        return (

            
            <AliceCarousel mouseTracking items={images} disableButtonsControls={true} autoPlayInterval={1000} autoPlay={true} infinite={true} responsive={responsive}/>
            
       
        );
    }
}

export default FooterSlider

// Don't forget to include the css in your page